var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar"},[_c('span',[_c('router-link',{staticClass:"btn-text",attrs:{"to":"/login"}},[_vm._v("登录")]),_vm._v("后，可以问我")],1),_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/spark/audio_icon.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }